import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import ReturnOrderTableHeader from './components/returnorder-table-header';
import DialogReturn from './components/dialog.return';
import UserTitle from '../components/user.title';
import UserSideMenu from '../components/user.side-menu';
import { API } from '../../../constants';
import _ from 'lodash';
import './returnorder.css';
import LayoutPreloadTransparent from '../../Preload/layout.preload-transparent';
import { formatNumber, StringToNumber } from '../../../utils/';

class ReturnOrderMain extends Component {
    state = {
        makeReturnData: this.props.getMakeRetureData,
        itemSelected: [],
        rowFocus: null,
        changeQty: 0,
        previewImages: [],
        details: '',
        hasErrorReasons: false,
    };

    handleItemSelectAll = event => {
        const { orderDetail } = this.state.makeReturnData;
        if (event.target.checked) {
            this.setState({ itemSelected: orderDetail.map(item => item.id) });
            return;
        }
        this.setState({ itemSelected: [] });
    };

    handleSingleItemSelect = (event, id) => {
        const { itemSelected } = this.state;
        const selectedIndex = itemSelected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(itemSelected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(itemSelected.slice(1));
        } else if (selectedIndex === itemSelected.length - 1) {
            newSelected = newSelected.concat(itemSelected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                itemSelected.slice(0, selectedIndex),
                itemSelected.slice(selectedIndex + 1)
            );
        }
        this.setState({ itemSelected: newSelected });
    };

    updateOrderDetail = (focusOrder, orderDetail) => {
        return orderDetail.map(item => {
            if (item.id === focusOrder.id) {
                return focusOrder;
            }
            return item;
        });
    };

    handleDecreaseQty = data => {
        const { makeReturnData } = this.state;
        const { amount } = data;
        const NewQty = amount - 1;
        if (NewQty !== 0) {
            data.amount = NewQty;
            const newMakeReturnOrderDetail = this.updateOrderDetail(data, makeReturnData.orderDetail);
            this.setState(prevState => ({
                ...prevState,
                makeReturnData: { ...prevState.makeReturnData, orderDetail: newMakeReturnOrderDetail }
            }));
        }
    };

    handleIncreaseQty = data => {
        const { makeReturnData } = this.state;
        const { amount, stock } = data;
        const NewQty = amount + 1;
        if (NewQty <= stock) {
            data.amount = NewQty;
            const newMakeReturnOrderDetail = this.updateOrderDetail(data, makeReturnData.orderDetail);
            this.setState(prevState => ({
                ...prevState,
                makeReturnData: { ...prevState.makeReturnData, orderDetail: newMakeReturnOrderDetail }
            }));
        }
    };

    handleQtyFocus = data => {
        const { id, amount } = data;
        this.setState({ rowFocus: id, changeQty: amount });
    };

    handleQtyChange = (e, data) => {
        const qty = e.target.value;
        const { stock } = data;
        this.setState({ changeQty: qty >= stock ? stock : qty });
    };

    handleQtyBlur = data => {
        const { makeReturnData, changeQty } = this.state;
        const NewQty = changeQty === '' || changeQty <= 0 ? 1 : changeQty;
        data.amount = NewQty;
        const newMakeReturnOrderDetail = this.updateOrderDetail(data, makeReturnData.orderDetail);
        this.setState(prevState => ({
            ...prevState,
            makeReturnData: { ...prevState.makeReturnData, orderDetail: newMakeReturnOrderDetail },
            rowFocus: null,
            changeQty: 0
        }));
    };

    handleSelectRemark = (remark, data) => {
        const { makeReturnData } = this.state;
        data.remark = remark;
        const newMakeReturnOrderDetail = this.updateOrderDetail(data, makeReturnData.orderDetail);
        this.setState(prevState => ({
            ...prevState,
            makeReturnData: { ...prevState.makeReturnData, orderDetail: newMakeReturnOrderDetail }
        }));
    };

    getFilesNormal = ({ target }) => {
        const { UserOpenDialogOverMaxFiles, UserOpenDialogFileTypeNotSupport } = this.props;
        const imageFiles = target.files;
        let dataUrl = null;

        if (imageFiles.length > 3) {
            UserOpenDialogOverMaxFiles();
        } else {
            let checkFilesType = 0;
            for (let index = 0; index < imageFiles.length; index++) {
                const { type } = imageFiles[index];
                if (type === 'image/png' || type === 'image/jpeg' || type === 'image/jpg') {
                    checkFilesType = checkFilesType + 1;
                }
            }

            if (checkFilesType === imageFiles.length) {
                this.setState({ previewImages: [] });

                for (let i = 0; i < imageFiles.length; i++) {
                    let img = document.createElement('img');
                    let reader = new FileReader();
                    reader.onload = e => {
                        img.src = e.target.result;
                        img.onload = () => {
                            var canvas = document.createElement('canvas');
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0);
                            var MAX_WIDTH = 1280;
                            var MAX_HEIGHT = 720;
                            var width = img.width;
                            var height = img.height;
                            if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
                                width = width;
                                height = height;
                            } else if (width / MAX_WIDTH > height / MAX_HEIGHT) {
                                width = MAX_WIDTH;
                                height = (height * MAX_WIDTH) / width;
                            } else {
                                width = (width * MAX_HEIGHT) / height;
                                height = MAX_HEIGHT;
                            }
                            canvas.width = width;
                            canvas.height = height;
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, width, height);
                            dataUrl = canvas.toDataURL('image/jpeg');

                            var blobBin = atob(dataUrl.split(',')[1]);
                            var array = [];
                            for(var i = 0; i < blobBin.length; i++) {
                                array.push(blobBin.charCodeAt(i));
                            }
                            var file = new Blob([new Uint8Array(array)], { type: dataUrl.match(/:image\/(png|jpg|jpeg)/)[0] });

                            const newImg = { strBase64: dataUrl, file };
                            this.setState(prevState => ({
                                ...prevState,
                                previewImages: [...prevState.previewImages, newImg]
                            }));
                        };
                    };
                    reader.readAsDataURL(imageFiles[i]);
                }
            } else {
                UserOpenDialogFileTypeNotSupport();
                this.setState({ previewImages: [] });
            }
        }
    };
    hadleSetReturnFormData = () => {
        const { itemSelected, makeReturnData, previewImages, details } = this.state;
        if(!details || details == '')
        {
            this.setState({hasErrorReasons: true});
            return;
        }
        
        this.setState({hasErrorReasons: false});
        const {
            UserOpenDialogNotSelect,
            UserOpenDialogSelectRemark,
            UserOpenDialogFileRequired,
            UserSubmitReturnFormData
        } = this.props;

        if (itemSelected.length === 0) {
            UserOpenDialogNotSelect();
        } else {
            //// check remark
            let filterReturnOrder = [];
            itemSelected.map(selectId => {
                const ItemSelected = _.filter(makeReturnData.orderDetail, item => item.id === selectId).map(item => ({ ...item, totalPrice: formatNumber(+item.amount * StringToNumber(item.price)) }));
                return filterReturnOrder.push(ItemSelected[0]);
            });

            if (_.find(filterReturnOrder, item => item.remark === 'default')) {
                UserOpenDialogSelectRemark();
            } else {
                if (previewImages.length === 0) {
                    UserOpenDialogFileRequired();
                } else {
                    UserSubmitReturnFormData(makeReturnData, filterReturnOrder, previewImages, details);
                }
            }
        }
    };

    render() {
        const { makeReturnData, itemSelected, rowFocus, changeQty, details, previewImages } = this.state;
        console.log(this.state);

        const {
            wording,
            submitFetching,
            dialogNotSelect,
            dialogOverMaxFile,
            dialogSelectRemark,
            dialogFileTypeNotSupport,
            dialogFileRequired,
            dialogSubmitError,
            UserCloseDialogNotSelect,
            UserCloseDialogOverMaxFiles,
            UserCloseDialogSelectRemark,
            UserCloseDialogFileTypeNotSupport,
            UserCloseDialogFileRequired,
            UserCloseDialogSubmitError
        } = this.props;

        return (
            <div className='main-wrapper shop oh'>
                {submitFetching && <LayoutPreloadTransparent />}

                <DialogReturn
                    id='dialogReturnOrderEmpty'
                    open={dialogNotSelect}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogReturnOrderEmpty}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogNotSelect}
                />

                <DialogReturn
                    id='dialogOverMaxFile'
                    open={dialogOverMaxFile}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogOverMaxFile}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogOverMaxFiles}
                />

                <DialogReturn
                    id='dialogSelectRemark'
                    open={dialogSelectRemark}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogSelectRemark}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogSelectRemark}
                />

                <DialogReturn
                    id='dialogFileTypeNotSupport'
                    open={dialogFileTypeNotSupport}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogFileTypeNotSupport}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogFileTypeNotSupport}
                />

                <DialogReturn
                    id='dialogFileRequired'
                    open={dialogFileRequired}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogFileRequired}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogFileRequired}
                />

                <DialogReturn
                    id='dialogSubmitError'
                    open={dialogSubmitError}
                    title={wording.usermenu.makeReturn.dialog.title}
                    bodyMessage={wording.usermenu.makeReturn.dialog.dialogSubmitError}
                    button={wording.usermenu.makeReturn.dialog.close}
                    onClose={UserCloseDialogSubmitError}
                />

                <UserTitle title={wording.usermenu.makeReturn.title} />
                <section className='section-wrap pt-70 pb-40 catalogue'>
                    <div className='container relative'>
                        <div className='row'>
                            <aside className='col-md-3 sidebar'>
                                <UserSideMenu />
                            </aside>
                            {makeReturnData && (
                                <div className='col-md-9 catalogue-col right mb-50 container-list-user'>
                                    <div className='row items-grid'>
                                        <div className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                                            <div>
                                                <p className='mr-10'>
                                                    <span className='caption white mr-10'>
                                                        {wording.purchase.invoiceNo}
                                                    </span>
                                                    <span className='white mr-10'>{makeReturnData.invoice}</span>
                                                    <span className='caption white mr-10'>
                                                        {wording.purchase.orderDate}
                                                    </span>
                                                    <span className='white mr-10'>{makeReturnData.date}</span>
                                                </p>
                                                <p>
                                                    <span className='caption white mr-10'>
                                                        {wording.purchase.status}
                                                    </span>
                                                    <span className='status-received mr-10'>
                                                        {makeReturnData.status}
                                                    </span>
                                                    {makeReturnData.deliveryNumber !== '' && (
                                                        <>
                                                            <span className='caption white mr-10'>
                                                                {wording.purchase.deliveryNo}
                                                            </span>
                                                            <span className='kerry-tracking pointer mr-10'>
                                                                {makeReturnData.deliveryNumber}
                                                            </span>
                                                        </>
                                                    )}
                                                </p>
                                            </div>
                                            <div className='table-wrap mb-30'>
                                                <table className='shop_table cart table'>
                                                    <ReturnOrderTableHeader
                                                        numSelected={itemSelected.length}
                                                        rowCount={makeReturnData.orderDetail.length}
                                                        onSelectAllClick={this.handleItemSelectAll}
                                                    />
                                                    <tbody>
                                                        {makeReturnData.orderDetail.map(product => {
                                                            const isSelected = itemSelected.indexOf(product.id) !== -1;
                                                            return (
                                                                <tr
                                                                    key={`return-${product.id}`}
                                                                    className='return_item'>
                                                                    <td>
                                                                        <input
                                                                            type='checkbox'
                                                                            className={`input-checkbox-${product.id}`}
                                                                            checked={isSelected}
                                                                            onClick={event => event.stopPropagation()}
                                                                            onChange={event =>
                                                                                this.handleSingleItemSelect(
                                                                                    event,
                                                                                    product.id
                                                                                )
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td className='product-thumbnail'>
                                                                        <div>
                                                                            <img
                                                                                src={`${API.PRODUCT_IMG_URL}${product.picture}`}
                                                                                alt={product.picture}
                                                                            />
                                                                        </div>
                                                                    </td>

                                                                    <td className='product-name'>
                                                                        <span className='white'>
                                                                            {product.productName}
                                                                        </span>

                                                                        <ul>
                                                                            {product.productSizeName !== 'N' && (
                                                                                <li className='white'>
                                                                                    {`${wording.usermenu.makeReturn.size}: ${product.productSizeName}`}
                                                                                </li>
                                                                            )}

                                                                            {product.color && (
                                                                                <li>
                                                                                    <div
                                                                                        style={{ display: 'flex' }}
                                                                                        className='color-select clearfix'>
                                                                                        <span
                                                                                            className='white'
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginRight: 4
                                                                                            }}>
                                                                                            {`${wording.usermenu.makeReturn.color}:`}
                                                                                        </span>
                                                                                        <ul className='color-swatches clearfix'>
                                                                                            <li>
                                                                                                <a
                                                                                                    className='pointer'
                                                                                                    style={{
                                                                                                        backgroundColor:
                                                                                                            product.color,
                                                                                                        width: 18,
                                                                                                        height: 18
                                                                                                    }}
                                                                                                />
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </td>

                                                                    <td className='product-quantity'>
                                                                        <div className='quantity buttons_added'>
                                                                            <input
                                                                                type='button'
                                                                                value='-'
                                                                                className='react_minus'
                                                                                onClick={() =>
                                                                                    this.handleDecreaseQty(product)
                                                                                }
                                                                            />
                                                                            <input
                                                                                title='Qty'
                                                                                className='input-text qty text white'
                                                                                type='number'
                                                                                value={
                                                                                    rowFocus === product.id
                                                                                        ? changeQty
                                                                                        : product.amount
                                                                                }
                                                                                onFocus={() =>
                                                                                    this.handleQtyFocus(product)
                                                                                }
                                                                                onChange={e =>
                                                                                    this.handleQtyChange(e, product)
                                                                                }
                                                                                onBlur={() =>
                                                                                    this.handleQtyBlur(product)
                                                                                }
                                                                            />
                                                                            <input
                                                                                type='button'
                                                                                value='+'
                                                                                className='react_plus'
                                                                                onClick={() =>
                                                                                    this.handleIncreaseQty(product)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </td>

                                                                    {isSelected ? (
                                                                        <td className='refund-remark'>
                                                                            <select
                                                                                className='mt-10'
                                                                                style={{ backgroundColor: '#fff' }}
                                                                                value={product.remark}
                                                                                onChange={e =>
                                                                                    this.handleSelectRemark(
                                                                                        e.target.value,
                                                                                        product
                                                                                    )
                                                                                }>
                                                                                <option value='default'>
                                                                                    เลือกเหตุผลในการเปลี่ยนสินค้า
                                                                                </option>
                                                                                <option value='สินค้ามีตำหนิ'>
                                                                                    สินค้ามีตำหนิ
                                                                                </option>
                                                                                <option value='สินค้าผิด/ไม่ถูกต้อง'>
                                                                                    สินค้าผิด/ไม่ถูกต้อง
                                                                                </option>
                                                                                <option value='สินค้าใช้งานไม่ได้'>
                                                                                    สินค้าใช้งานไม่ได้
                                                                                </option>
                                                                                <option value='สินค้าไม่ตรงตามข้อมูลบนเว็บไซต์'>
                                                                                    สินค้าไม่ตรงตามข้อมูลบนเว็บไซต์
                                                                                </option>
                                                                            </select>
                                                                        </td>
                                                                    ) : (
                                                                            <td className='refund-remark'></td>
                                                                        )}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='row return-form'>
                                                <div className='col-md-12'>
                                                    <div className='row'>
                                                        <div className='col-md-offset-1 col-md-3 text-right'>
                                                            <span className='white'>
                                                                {wording.usermenu.makeReturn.captionLabel.details}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <textarea
                                                                placeholder=''
                                                                rows='3'
                                                                value={details}
                                                                onChange={e =>
                                                                    this.setState({ details: e.target.value })
                                                                }
                                                            />
                                                            {this.state.hasErrorReasons ? <p className='error'>{wording.usermenu.makeReturn.errorRemark}</p> : null}

                                                        </div>

                                                        {previewImages.length > 0 && (
                                                            <div className='col-md-12'>
                                                                <div className='row'>
                                                                    <div className='col-md-1' />
                                                                    {previewImages.map((img, index) => {
                                                                        return (
                                                                            <div
                                                                                key={`image${index}`}
                                                                                className='col-md-3'>
                                                                                <div className='thumbnail'>
                                                                                    <img
                                                                                        src={img.strBase64}
                                                                                        alt={`image${index}`}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className='col-md-offset-1 col-md-3 text-right'>
                                                            <span className='white'>
                                                                {wording.usermenu.makeReturn.captionLabel.upload}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <input
                                                                type='file'
                                                                multiple
                                                                onChange={e => this.getFilesNormal(e)}
                                                            />
                                                        </div>

                                                        <div className='col-md-offset-4 col-md-6 mt-20'>
                                                            <button
                                                                className='btn btn-md btn-light'
                                                                onClick={() => this.hadleSetReturnFormData()}>
                                                                {wording.usermenu.makeReturn.selectsuccess}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = ({ user, language }) => ({
    wording: language.wording,
    getMakeRetureData: user.makeReturn.data,
    submitFetching: user.makeReturn.submitFetching,
    dialogNotSelect: user.makeReturn.dialogNotSelect,
    dialogOverMaxFile: user.makeReturn.dialogOverMaxFile,
    dialogSelectRemark: user.makeReturn.dialogSelectRemark,
    dialogFileTypeNotSupport: user.makeReturn.dialogFileTypeNotSupport,
    dialogFileRequired: user.makeReturn.dialogFileRequired,
    dialogSubmitError: user.makeReturn.dialogSubmitError
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            UserOpenDialogNotSelect: Actions.UserOpenDialogNotSelect,
            UserSubmitReturnFormData: Actions.UserSubmitReturnFormData,
            UserCloseDialogNotSelect: Actions.UserCloseDialogNotSelect,
            UserOpenDialogOverMaxFiles: Actions.UserOpenDialogOverMaxFiles,
            UserCloseDialogOverMaxFiles: Actions.UserCloseDialogOverMaxFiles,
            UserOpenDialogSelectRemark: Actions.UserOpenDialogSelectRemark,
            UserCloseDialogSelectRemark: Actions.UserCloseDialogSelectRemark,
            UserOpenDialogFileTypeNotSupport: Actions.UserOpenDialogFileTypeNotSupport,
            UserCloseDialogFileTypeNotSupport: Actions.UserCloseDialogFileTypeNotSupport,
            UserCloseDialogSubmitError: Actions.UserCloseDialogSubmitError,
            UserOpenDialogFileRequired: Actions.UserOpenDialogFileRequired,
            UserCloseDialogFileRequired: Actions.UserCloseDialogFileRequired
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnOrderMain);
